export const VolumeUpIcon = ({ color = "#A7A7A7", size = 29, ...props }) => (
    <svg
        width={size}
        height={size * (28 / 29)}
        viewBox="0 0 29 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#volume-up-clip)">
            <path
                d="M7 11.6055V16.3945H10.3333L14.5 20.3854V7.6146L10.3333 11.6055H7ZM12.8333 11.4698V16.5302L11.025 14.7982H8.66667V13.2018H11.025L12.8333 11.4698ZM18.25 14C18.25 12.5872 17.4 11.374 16.1667 10.7834V17.2087C17.4 16.626 18.25 15.4128 18.25 14ZM16.1667 7V8.64424C18.575 9.33067 20.3333 11.4698 20.3333 14C20.3333 16.5302 18.575 18.6693 16.1667 19.3558V21C19.5083 20.2737 22 17.4162 22 14C22 10.5838 19.5083 7.72634 16.1667 7Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="volume-up-clip">
                <rect width="28" height="28" fill="white" transform="translate(0.927734)" />
            </clipPath>
        </defs>
    </svg>
);
